import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Children, useMemo } from 'react';
export function useContent(children) {
  return useMemo(function () {
    return Children.toArray(children).reduce(function (res, item) {
      var _a;
      var placement = (_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.placement;
      return placement ? Object.assign(Object.assign({}, res), _defineProperty({}, placement, item)) : res;
    }, {
      start: null,
      end: null
    });
  }, [children]);
}